import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthContext";
import { API_URL } from "../../../../config";
import styles from "./styles/EquipmentWork.module.scss";

function EquipmentWork({ selectedBoilerRoom }) {
  const { authTokens } = useContext(AuthContext);
  const [boilers, setBoilers] = useState([]);
  const [pumps, setPumps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEquipment = async () => {
      if (!selectedBoilerRoom) {
        setBoilers([]);
        setPumps([]);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const [boilersResponse, pumpsResponse] = await Promise.all([
          fetch(`${API_URL}/TControl/boiler/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authTokens.access}`,
            },
          }),
          fetch(`${API_URL}/TControl/boilerhousepump/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authTokens.access}`,
            },
          }),
        ]);

        if (!boilersResponse.ok || !pumpsResponse.ok) {
          throw new Error("Ошибка при загрузке оборудования");
        }

        const boilersData = await boilersResponse.json();
        const pumpsData = await pumpsResponse.json();

        setBoilers(
          Array.isArray(boilersData)
            ? boilersData.filter((boiler) => boiler.boilerhouse_id === selectedBoilerRoom.pk)
            : []
        );
        setPumps(
          Array.isArray(pumpsData)
            ? pumpsData.filter((pump) => pump.boilerhouse_id === selectedBoilerRoom.pk)
            : []
        );
      } catch (err) {
        console.error("Ошибка при загрузке оборудования:", err);
        setError(err.message);
        setBoilers([]);
        setPumps([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEquipment();
  }, [selectedBoilerRoom, authTokens]);

  return (
    <div className={styles.container}>
      {loading && <p className={styles.loading}>Загрузка данных...</p>}
      {error && <p className={styles.error}>Ошибка: {error}</p>}

      {selectedBoilerRoom && (
        <div className={styles.tableContainer}>
          <h4 className={styles.tableTitle}>Котлы</h4>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Номер</th>
                <th className={styles.tableHeader}>Тип</th>
                <th className={styles.tableHeader}>Статус</th>
                <th className={styles.tableHeader}>Мощность (Гкал/ч)</th>
              </tr>
            </thead>
            <tbody>
              {boilers.length > 0 ? (
                boilers.map((boiler) => (
                  <tr key={boiler.pk} className={styles.tableRow}>
                    <td className={styles.tableCell}>{boiler.number}</td>
                    <td className={styles.tableCell}>{boiler.type || "-"}</td>
                    <td className={styles.tableCell}>{boiler.status || "-"}</td>
                    <td className={styles.tableCell}>{boiler.installed_power || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell} colSpan="4">
                    {loading ? "Загрузка..." : "Нет доступных котлов"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <h4 className={styles.tableTitle}>Насосы</h4>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.tableHeader}>Номер</th>
                <th className={styles.tableHeader}>Тип</th>
                <th className={styles.tableHeader}>Статус</th>
                <th className={styles.tableHeader}>Производительность (м³/ч)</th>
                <th className={styles.tableHeader}>Мощность (кВт)</th>
              </tr>
            </thead>
            <tbody>
              {pumps.length > 0 ? (
                pumps.map((pump) => (
                  <tr key={pump.pk} className={styles.tableRow}>
                    <td className={styles.tableCell}>{pump.number}</td>
                    <td className={styles.tableCell}>{pump.type || "-"}</td>
                    <td className={styles.tableCell}>{pump.status || "-"}</td>
                    <td className={styles.tableCell}>{pump.pump_output || "-"}</td>
                    <td className={styles.tableCell}>{pump.power || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell} colSpan="5">
                    {loading ? "Загрузка..." : "Нет доступных насосов"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default EquipmentWork;